:root {
  color: #22241f;
  font-family: "Microsoft YaHei UI", "PingFang SC", "Noto Sans CJK SC", system-ui, sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
  background: #f1f0eb;
}

button,
textarea {
  font: inherit;
}

button:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(108, 122, 75, 0.28);
  outline-offset: 2px;
}

.rtrugs-shell {
  display: grid;
  min-height: 100vh;
  grid-template-rows: 64px minmax(0, 1fr) 34px;
  background:
    radial-gradient(circle at 66% 8%, rgba(210, 204, 182, 0.34), transparent 30%), #f1f0eb;
}

.topbar {
  z-index: 2;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr);
  align-items: center;
  gap: 20px;
  padding: 0 22px;
  border-bottom: 1px solid #d8d5ca;
  background: rgba(250, 249, 245, 0.95);
  box-shadow: 0 4px 16px rgba(38, 38, 30, 0.04);
}

.brand-lockup,
.environment-strip,
.top-actions,
.connection-state {
  display: flex;
  align-items: center;
}

.brand-lockup {
  gap: 11px;
}

.brand-mark {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 10px;
  color: #f9f8f3;
  background: #30332b;
  font-family: Georgia, serif;
  letter-spacing: -1px;
}

.brand-lockup strong,
.brand-lockup small {
  display: block;
}

.brand-lockup strong {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  letter-spacing: 0.02em;
}

.brand-lockup small {
  margin-top: 2px;
  color: #79796f;
  font-size: 10px;
}

.environment-strip {
  gap: 8px;
  font-size: 12px;
}

.environment-strip > span {
  padding: 5px 9px;
  border-radius: 999px;
}

.environment-badge {
  color: #4d5144;
  background: #e6e4dc;
}

.simulation-badge {
  color: #7a4a23;
  background: #f4dfc4;
  font-weight: 700;
}

.connection-state {
  gap: 6px;
  color: #64665e;
}

.connection-state i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #c28a53;
}

.top-actions {
  justify-content: flex-end;
  gap: 8px;
}

.top-actions button {
  min-height: 34px;
  border: 1px solid #d5d2c7;
  border-radius: 8px;
  color: #44473e;
  background: #f8f7f2;
  cursor: pointer;
}

.pause-button {
  padding: 0 12px;
  border-color: #d7ad8a !important;
  color: #7c4524 !important;
  background: #fff7ef !important;
}

.icon-button,
.avatar-button {
  padding: 0 11px;
}

.application-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: 196px minmax(520px, 1fr) 318px;
}

.center-navigation {
  display: flex;
  min-height: 0;
  flex-direction: column;
  padding: 18px 13px 12px;
  border-right: 1px solid #d4d1c6;
  color: #d8dacd;
  background: #30332b;
}

.center-navigation button {
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 7px;
  width: 100%;
  min-height: 48px;
  padding: 0 11px;
  border: 0;
  border-radius: 9px;
  color: #c4c7ba;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.center-navigation button:hover {
  background: rgba(255, 255, 255, 0.05);
}

.center-navigation button.active {
  color: #fffdf5;
  background: #555b48;
  box-shadow: inset 3px 0 #c7b786;
}

.nav-index {
  color: #999d8e;
  font-family: Georgia, serif;
  font-size: 11px;
}

.navigation-footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding: 13px 10px 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #9ea092;
  font-size: 11px;
}

.navigation-footer strong {
  color: #dcdecf;
}

.workspace {
  min-width: 0;
  overflow: auto;
  padding: clamp(18px, 2vw, 30px);
}

.workspace-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.eyebrow {
  margin: 0 0 7px;
  color: #77796d;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.workspace-heading h1 {
  margin: 0;
  font-family: Georgia, "Songti SC", serif;
  font-size: clamp(28px, 2.2vw, 38px);
  font-weight: 500;
}

.workspace-heading p:not(.eyebrow) {
  max-width: 670px;
  margin: 8px 0 0;
  color: #66675e;
  font-size: 13px;
  line-height: 1.7;
}

.workspace-heading time {
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid #d4d0c3;
  border-radius: 7px;
  color: #737369;
  background: rgba(255, 255, 255, 0.45);
  font-size: 11px;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  gap: 11px;
  margin-top: 24px;
}

.status-grid article {
  min-height: 108px;
  padding: 15px;
  border: 1px solid #d9d6cc;
  border-radius: 10px;
  background: rgba(250, 249, 245, 0.78);
  box-shadow: 0 8px 22px rgba(47, 48, 40, 0.035);
}

.status-grid span,
.status-grid small,
.status-grid strong {
  display: block;
}

.status-grid span {
  color: #686a60;
  font-size: 11px;
}

.status-grid strong {
  margin: 7px 0 4px;
  color: #30332b;
  font-family: Georgia, serif;
  font-size: 25px;
  font-weight: 500;
}

.status-grid small {
  color: #929187;
  font-size: 10px;
}

.conversation-panel {
  display: flex;
  min-height: 420px;
  flex-direction: column;
  margin-top: 14px;
  padding: 18px;
  border: 1px solid #d8d5cb;
  border-radius: 12px;
  background: rgba(250, 249, 245, 0.84);
  box-shadow: 0 10px 30px rgba(47, 48, 40, 0.045);
}

.system-message {
  max-width: 720px;
  padding: 14px 16px;
  border-left: 3px solid #8c9275;
  border-radius: 4px 9px 9px 4px;
  background: #eeeee6;
}

.message-label {
  color: #666b56;
  font-size: 10px;
  font-weight: 700;
}

.system-message p {
  margin: 7px 0 0;
  color: #4f5149;
  font-size: 12px;
  line-height: 1.75;
}

.empty-timeline {
  display: grid;
  flex: 1;
  place-content: center;
  color: #87877d;
  text-align: center;
}

.empty-timeline div {
  color: #9ba087;
  font-family: Georgia, serif;
  font-size: 24px;
}

.empty-timeline p {
  margin: 8px 0 4px;
  color: #5f6158;
  font-size: 12px;
}

.empty-timeline small {
  font-size: 10px;
}

.composer {
  padding: 12px;
  border: 1px solid #d0cdc2;
  border-radius: 10px;
  background: #fffefa;
  box-shadow: 0 5px 18px rgba(42, 43, 35, 0.05);
}

.composer label {
  display: block;
  color: #66685f;
  font-size: 10px;
  font-weight: 700;
}

.composer textarea {
  width: 100%;
  margin-top: 5px;
  resize: vertical;
  border: 0;
  color: #30322d;
  background: transparent;
  line-height: 1.6;
}

.composer textarea::placeholder {
  color: #aaa99f;
}

.composer > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid #ebe8df;
}

.composer span {
  color: #9a998e;
  font-size: 9px;
}

.composer button {
  min-height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 7px;
  color: #fffef8;
  background: #505745;
  cursor: pointer;
}

.composer button:disabled {
  color: #93968a;
  background: #e3e4dd;
  cursor: not-allowed;
}

.context-panel {
  min-width: 0;
  overflow: auto;
  padding: 21px 18px;
  border-left: 1px solid #d4d1c6;
  background: rgba(243, 242, 236, 0.94);
}

.context-panel section {
  padding: 17px;
  border: 1px solid #d8d5cb;
  border-radius: 10px;
  background: #faf9f4;
}

.context-panel section + section {
  margin-top: 12px;
}

.context-panel h2 {
  margin: 0;
  color: #404239;
  font-family: Georgia, "Songti SC", serif;
  font-size: 16px;
  font-weight: 500;
}

.context-panel p:not(.eyebrow) {
  margin: 9px 0;
  color: #77776e;
  font-size: 11px;
  line-height: 1.7;
}

.context-panel dl {
  margin: 14px 0 0;
}

.context-panel dl div {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-top: 1px solid #e5e2d9;
  font-size: 10px;
}

.context-panel dt {
  color: #8c8c82;
}

.context-panel dd {
  margin: 0;
  color: #4f5248;
  font-weight: 700;
}

.foundation-card code {
  display: block;
  overflow: hidden;
  margin-top: 10px;
  padding: 8px;
  border-radius: 6px;
  color: #536047;
  background: #edf0e8;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.risk-card {
  border-color: #e0c5a9 !important;
  background: #fff8ef !important;
}

.risk-card span {
  color: #87562e;
  font-size: 10px;
  font-weight: 700;
}

.statusbar {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 0 16px;
  border-top: 1px solid #d4d1c7;
  color: #7e7e74;
  background: #e8e6df;
  font-size: 9px;
}

.statusbar strong {
  margin-left: auto;
  color: #85542e;
  letter-spacing: 0.08em;
}

@media (max-width: 1180px) {
  .application-grid {
    grid-template-columns: 168px minmax(0, 1fr);
  }

  .context-panel {
    display: none;
  }

  .status-grid {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
}

@media (max-width: 760px) {
  .rtrugs-shell {
    grid-template-rows: auto minmax(0, 1fr) auto;
  }

  .topbar {
    grid-template-columns: 1fr auto;
    padding: 10px 12px;
  }

  .environment-strip {
    display: none;
  }

  .top-actions .icon-button,
  .top-actions .avatar-button {
    display: none;
  }

  .application-grid {
    grid-template-columns: 64px minmax(0, 1fr);
  }

  .center-navigation {
    padding: 12px 7px;
  }

  .center-navigation button {
    display: grid;
    min-height: 46px;
    grid-template-columns: 1fr;
    place-items: center;
    padding: 0;
  }

  .center-navigation button span:last-child,
  .navigation-footer {
    display: none;
  }

  .workspace-heading time,
  .statusbar span:nth-child(3) {
    display: none;
  }

  .status-grid {
    grid-template-columns: 1fr 1fr;
  }

  .workspace {
    padding: 14px;
  }

  .conversation-panel {
    min-height: 360px;
  }

  .statusbar {
    flex-wrap: wrap;
    gap: 6px 12px;
    padding: 6px 10px;
  }
}
